var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar=Aktif"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Category"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    opacity: 0.4,
    d: "M12.3477 2.38843H14.8872C15.9389 2.38843 16.7911 3.24782 16.7911 4.3084V6.86932C16.7911 7.9299 15.9389 8.78929 14.8872 8.78929H12.3477C11.296 8.78929 10.4438 7.9299 10.4438 6.86932V4.3084C10.4438 3.24782 11.296 2.38843 12.3477 2.38843Z",
    fill: "url(#paint0_linear_493_867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69491 2.38843H6.23438C7.28608 2.38843 8.13828 3.24782 8.13828 4.3084V6.86932C8.13828 7.9299 7.28608 8.78929 6.23438 8.78929H3.69491C2.64321 8.78929 1.79102 7.9299 1.79102 6.86932V4.3084C1.79102 3.24782 2.64321 2.38843 3.69491 2.38843ZM3.69491 10.9876H6.23438C7.28608 10.9876 8.13828 11.847 8.13828 12.9075V15.4685C8.13828 16.5283 7.28608 17.3884 6.23438 17.3884H3.69491C2.64321 17.3884 1.79102 16.5283 1.79102 15.4685V12.9075C1.79102 11.847 2.64321 10.9876 3.69491 10.9876ZM14.8871 10.9876H12.3476C11.2959 10.9876 10.4438 11.847 10.4438 12.9075V15.4685C10.4438 16.5283 11.2959 17.3884 12.3476 17.3884H14.8871C15.9388 17.3884 16.791 16.5283 16.791 15.4685V12.9075C16.791 11.847 15.9388 10.9876 14.8871 10.9876Z",
    fill: "url(#paint1_linear_493_867)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_867",
    x1: 9.9839,
    y1: 0.7461,
    x2: 15.2518,
    y2: 10.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_493_867",
    x1: 0.704059,
    y1: -1.46026,
    x2: 12.9913,
    y2: 21.6814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA8517"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.886513a1aa904cc8e115d5e62f05b986.svg";
export { ForwardRef as ReactComponent };